// extracted by mini-css-extract-plugin
export default {"icon":"FoqXlQ","iconWithoutBackground":"R6UEaB","background":"SmJtyc"};